const locales = {
    tr: {
      layoutTitle: "Octoopi Van Konfigratör",
      layoutFooter: "© 2024 Octoopi Systems",
      pages: "Sayfalar",
      outputs: "Çıkışlar",
      addPage: "Sayfa Ekle",
      addOutput: "Çıkış Ekle",
      deleteConfirm: "Bu öğeyi silmek istediğinizden emin misiniz?",
      yes: "Evet",
      no: "Hayır",
      saveChanges: "Değişiklikleri Kaydet ve İndir",
      firstRowCapacity: "Birinci Sıra Kapasitesi",
      secondRowCapacity: "İkinci Sıra Kapasitesi",
      pageAlias: "Sayfa Takma Adı",
      socketpin: "Socketpin",
      type: "Tip",
      currentLimit: "Akım Limiti (A)",
      page: "Sayfa",
      column: "Kolon",
      row: "Sıra",
      clone: "Klonla",
      currentGreenLimit: "Akım Yeşil Limit (A)",
      icon: "İkon",
      nameTR: "Adı (TR)",
      nameGB: "Adı (GB)",
      nameDE: "Adı (DE)",
      delete: "Sil",
      dkvi: "Değişiklikleri Kaydet ve İndir",
      forceShutDownVoltage: "Zorunlu kapanma voltajı (V)",
      optionalDownVoltage: "İsteğe bağlı kapanma voltajı",
      startWarnVoltage: "Başlangıç uyarı voltajı (V)",
      recoverVoltage: "Kurtarma voltajı",
      forceShutDownTime: "Zorunlu kapanma süresi (saniye)",
      setting: "Ayarlar",
      shortCircuitSocketpin: "Kısa devre soket pini",  
      openCircuitSocketpin: "Açık devre soket pini",
      shortCircuitVoltage: "Kısa devre voltajı (V)",
      openCircuitVoltage: "Açık devre voltajı (V)",
      manualOverrideDuration: "Geçersiz kılma süresi (saniye)",
      relay: "Röle",
      active: "Etkinleştirmek",
      floats: "Şamandıralar",
      voltages : "Voltajlar",
      inputs: "Girişler",
      addInput: "Giriş Ekle",
      addVoltage: "Voltaj Ekle",
      addFloat: "Şamandıra Ekle",
      empty: "Boş",
      water: " Temiz Su",
      drain: "Kirli Su",
      gray: "Gri Su",
      purpose: "Amaç",
      warnPercent: "Uyarı Yüzdesi",
      errorPercent: "Hidrafor Durdurma %",
      lock_pin: "Hidrafor Çıkışı",
      enable: "Görünüle",
      vavienOutput: "Vavien Çıkışı",
      disabled: "Etkin Değil",
      enabled: "Etkin",
      Fix: "Sabit",  
      selectIcon: "İkon Seçimi",
      deleteClone:"Klonu Sil",
      page2: "Sayfa 2",
      column2: "Kolon 2",
      row2: "Sıra 2",
      optional : "Opsiyonel",
      companyName : "Firma Adı",
      caravanType : "Karavan Tipi",
      description : "Açıklama",
      customerNameSurname : "Müşteri Adı Soyadı",
      customerPhone : "Müşteri Telefon",
      customerCountry : "Müşteri Ülkesi",
      customerInformation : "Müşteri Bilgileri",
      howUsing: "Nasıl Kullanılır?",
      adminLogin : "Admin Giriş",
      oneContent: "Octoopi Van serisinin en temel ürünleri olan B ve S serileri karavan kullanıcılarına yaşam mahalli ile ilgili bilgi edinme konforunu sunmaktadır. Ürünlerimiz dokunmatik kullanıcı ekranı ve güç kontrol ara birimi olmak üzere iki parçadan oluşmakta, 4.3 ve 7 inch olmak üzere iki farklı ekran seçeneği sunmaktadır. Kullanıcılar özellikle gelişmiş ara yüzü ve teknolojik güç kontrol ünitesi sayesinde her türlü bilgiyi B ve S serisi ürünler ile alabilmektedir. MultiColor ve Glass+Glass kapasitif dokunmatik ekranı ile cep telefonu kolaylığında kullanım deneyimi sunar. Yarı iletken güç sürücüleri ve dijital/analog girişleri ile; akıllı bir sistemi Octoopi Van Series ile sizlere sunmaktayız. Tasarımı ve üretimi yerli olan Octoopi’nin kurulum ve teknik desteği ile satış sonrasında da ayrı bir memnuniyet siz değerli kullanıcılarımızı bekliyor.",
      requestHelp : "Yarım Talebinde Bulunun",
      areaRequired : "Bu alan gereklidir.",
      titile : "Başlık",
      plaseEnter: "Size ulaşabilmemiz adına E-Mail adresinizi giriniz.",
      helpReq:"Yardım talebinizle ilgili detayları buraya yazınız...",
      sendRequest : "Talebi Gönder.",
      outputPin : "Çıkış Pini",
      inputPin: "Giriş Pini",
      voltagesPin : "Voltaj Pini",
      floatsPin : "Şamandra Pini",
      outputName : "Çıkış",
      inputName : "Giriş",
      voltageName : "Voltaj",
      floatName : "Şamandra",
      sgy : "Sisteme Giriş Yap",
      email : "Email Adresi",
      password : "Şifre",
      newPassword: "Yeni Şifre",
      confirmPassword: "Şifre Tekrar",
      passwordMismatch: "Şifreler uyuşmuyor!",
      passwordUpdateTitle: "Şifre Güncelle",
      passwordSuccess: "Şifre başarıyla güncellendi.",
      gy : "Giriş Yap",
      hym : "Hesabınız yok mu?",
      ho: "Hesap oluşturun",
      sgyö: "Sisteme giriş yapmadan önce",
      kog: "kayıt olmanız gerekmektedir.",
      ehv: "Eğer hesabınız varsa",
      sükgy : "üst köşeden giriş yapabilirsiniz.",
      kf : "Kulanıcı Formu",
      name : "Adınız",
      surname : "Soyadı",
      fa : "Firma Adı",
      kt : "Karavan Tipi",
      description : "Açıklama",
      customerPhone : "Müşteri Telefon",
      country: "Ülke",
      submit: "Kayıt ol",
      login : "Giriş",
      ho : "Hesap oluştur.",
      kl : "Konfigürasyon Listeleme",
      yke : "Yeni Konfigürasyon Ekle",
      kdi : "Konfigürasyon Dosyasını İndir",
      ot: "Oluşturulma Tarihi",
      gt : "Güncelleme Tarihi",
      dowland : "İndir",
      nk : "Nasıl Kullanılır. ",
      sae : "1. Sayfalar Ekranı",
      sefeat: "Sayfalar ekranları, farklı ekran arayüzlerini temsil eder. En fazla 10 sayfa olacak şekilde çoğaltılabilir. Konfigürasyon sırasında bu sayfaların kapasitesi belirlenir.Her sayfada maksimum 5, minimum 0 adet ikon yeri seçilebilir. Öncelikle bu aşamanın tamamlanması gereklidir.",
      içç : "2. Çıkışlar",
      bepy : "Bu ekranda çıkış pinleri yapılandırılır. Akım limiti ve pin belirlenir. Akım Limiti: Belirlenen maksimum akım değeridir. Akım Yeşil Limit: Cihazın normal çalıştığı minimum akım seviyesidir. Çıkışı etkinleştirmek için tipi “etkin” olarak seçilmelidir.",
      titlee: "Başlık",
      mail : "E-Mail",
      description : "Açıklama",
      tb : "Talebi Gönder",
      ytb : "Yardım Talbinde Bulun",
      search : "Ara",
      clean : "Temizle",
      yb : "Yardım Başlığı",
      ya : "Yardım Açıklaması",
      km : "Kullanıcı Maili",
      ci : "Konfig İndir",
      cid: "Konfig Id",
      ka : "Kullanıcı Adı",
      mid : "Müşteri Id",
      kaa : "Kullanıcı Adı Ara",
      mia : "Müşteri Id Ara",
      adi : "Adı",
      soyadi : "Soyadı",
      işlem : "İşlem",
      exit : "Çıkış Yap",
      profile : "Profilim",
      konfig: "Konfigürasyonlarım",
      ukb : "User Konfigürasyon Bilgileri",
      ub: "User Bilgileri",
      kyt : "Kullanıcı Yardım Talepleri",
      aylalg : "Akım Yeşil Limiti, Akım Limitini Geçemez!",
      negatifdg: "Negatif değer giremezsiniz.",
      tsuiuy: "Temiz su için uyarı yüzdesi, hata yüzdesinden büyük olmalı.",
      kgsiu : "Kirli/Gri su için uyarı yüzdesi, hata yüzdesinden küçük olmalı.",
      kag : "Konfigürasyon Adı",
      kaara : "Konfigürasyon adıyla ara",


      profilbg : "Profil başarıyla güncellendi.",
      profilbas:"Güncelleme başarısız.",
      bhataol: "Bir hata oluştu.",
      profbilgi : "Profil Bilgileri",
      update: "Güncelle",
      
      temprature : "Sıcaklık",
      numberOfTemprature : "Numara",
      isTempratureEnable : "Sıcaklık Aktiflik",
      location : "Bulunduğu Konum",
      right : "Sağ",
      left :"Sol",

      removeFilses : "Dosyayı Sil",
      showFiles : "Dosyayı Görüntüle",
      fileOperation: "Dosya İşlemleri",

      succes : "Başarılı",

      açıklamatürkçe : "Kullanıcı arayüzünde Türkçe seçildiğinde bu isim gösterilir.",
      açılamaIngülüzce : "Kullanıcı arayüzünde İngilizce seçildiğinde bu isim gösterilir.",
      açıklamaalmanca : "Kullanıcı arayüzünde Almanca seçildiğinde bu isim gösterilir.",

      klonlasayfa : "İkinci konumda gösterileceği sayfa numarasını seçin.",
      klonlasıranumarası : "İkinci konumda gösterileceği sıra numarasını seçin.",
      klonladasırakolonnumarası : "Ikinci konumda gösterileceği kolon numarasını seçin.",

      İkonaçıklama : "Kullanılacak ikonu seçin.",

      voltagepinaçıklama : "Bu voltaj sensörünün bağlanacağı fiziksel pin numarasını seçin. Her pin sadece bir kez kullanılabilir.",
      voltagenableaçıklama : "Bu voltaj sensörünün aktif olup olmayacağını seçin.",
      pagevoltajaçıklama : "Bu voltaj sensörünün gösterileceği sayfa numarasını seçin.",
      voltajaçıklamaymış : "Bu voltaj sensörünün gösterileceği sıra numarasını seçin.",
      voltajsensörükolonnum : "Bu voltaj sensörünün gösterileceği kolon numarasını seçin.",
      şamandırapinaçıklama : "Bu şamandıra sensörünün bağlanacağı fiziksel pin numarasını seçin. Her pin sadece bir kez kullanılabilir.",
      enableaçıklamamyşs : "Bu şamandıra sensörünün aktif olup olmayacağını seçin.",
      sensörtüpaçıklaama : "Şamandıra sensörünün tipini seçin.",
      purpeseeaçıklamaa : "Bu şamandıra sensörünün amacını seçin (su, atık su veya gri su).",
      uyarıverecekaçıklama : "Uyarı verilecek yüzde seviyesini girin.",
      errorpensentaçıklama : "Hata verilecek yüzde seviyesini girin.",
      lokpinaçıklama : "Bu şamandıra sensörüne bağlı kilit pin'ini seçin.",
      şamandırasayfanum : "Bu şamandıra sensörünün gösterileceği sayfa numarasını seçin.",
      şamandırasıranumarası : "Bu şamandıra sensörünün gösterileceği sıra numarasını seçin.",
      kollonumarasışamadnıra : "Bu şamandıra sensörünün gösterileceği kolon numarasını seçin.",

      röleaçıkalmalat : "Rölenin aktif veya pasif durumunu belirler. Aktif olduğunda röle çalışabilir.",
      şortkatbirşeymişney : "Kısa devre durumu için kullanılacak fiziksel pin numarası. Her pin yalnızca bir kez kullanılabilir.",
      açıkdevrebirşeymişneymişondan : "Açık devre durumu için kullanılacak fiziksel pin numarası. Her pin yalnızca bir kez kullanılabilir.",
      kısadevredurumdauygulanacak : "Kısa devre durumunda uygulanacak voltaj değeri (Volt cinsinden). 8V ile 100V arası değer girilebilir.",
      açıkdevredurumuaçıklama : "Açık devre durumunda uygulanacak voltaj değeri (Volt cinsinden). 8V ile 100V arası değer girilebilir.",
      manuelmüdahalesanresi : "Manuel müdahale süresi (saniye cinsinden). 0 ile 86400 saniye (24 saat) arası değer girilebilir.",
      sistemizrlakapat : "Sistemin zorla kapanacağı kritik düşük voltaj değeri. Bu değerin altına düştüğünde sistem güvenlik için otomatik olarak kapanır.",
      sistemizorlakapatmavoltaj : "İsteğe bağlı kapatma voltajı. Bu değere ulaşıldığında sistem kullanıcı tercihine göre kapatılabilir.",
      uyarıbaşlatmavoltajı : "Uyarı başlama voltajı. Bu değerin altına düştüğünde sistem düşük batarya uyarısı vermeye başlar.",
      kurtarmavoltajıaçıklama : "Kurtarma voltajı. Sistem bu voltaj değerine ulaştığında normal çalışma moduna geri döner ve uyarılar kapanır.",
      zorlakapatmaaçıklama : "Zorla kapatma süresi. Kritik voltaj seviyesine ulaştıktan sonra sistemin kapatılması için beklenecek süre (saniye cinsinden).",
      sıcaklıksensörüaktifpasif : "Sıcaklık sensörünün aktif/pasif durumunu belirler. Aktif olduğunda sensör ölçüm yapar.",
      sıcaklsısensörükonum : "Sıcaklık sensörünün yerleşim konumunu belirler (sağ veya sol taraf).",
      sıcaklıksensörüikon : "Sıcaklık sensörü için görsel ikon seçimi. Arayüzde sensörü temsil edecek simgeyi belirler.",
      rowKapesite : "Birinci satırda gösterilecek maksimum öğe sayısını belirler. Bu değer sayfanın görsel düzenini ve içerik kapasitesini etkiler.",
      rowkapesite2 : "İkinci satırda gösterilecek maksimum öğe sayısını belirler. Boş seçilirse ikinci satır kullanılmaz ve gizlenir.",
      benzersizIsim : "Bu sayfa için benzersiz bir isim belirleyin. Bu isim navigasyon ve yönetim amaçlı kullanılacaktır.",
      outputPinAcıklama : "Bu çıkışın bağlanacağı fiziksel pin numarasını seçin. Her pin sadece bir kez kullanılabilir ve diğer çıkışlarla çakışmamalıdır.",
      röleAcıklama : "Çıkışın çalışma tipini belirler. Disabled: Devre dışı, Enabled: Etkin, Fix: Sabit çalışma, Relay: Röle kontrolü",
      currenlimitacıklama : "Bu çıkışın maksimum akım limitini belirler (Amper cinsinden). Güvenlik için bu değeri aşmamalıdır.",
      outputSayfa : "Bu çıkışın hangi sayfa üzerinde görüntüleneceğini belirler. Sayfalar arasında organize etmek için kullanılır.",
      outuptSatır : "Bu çıkışın sayfada hangi satırda yer alacağını belirler. Önce sayfa seçilmelidir.",
      stunoutput : "Bu çıkışın seçilen satırda hangi sütunda yer alacağını belirler. Önce sayfa ve satır seçilmelidir.",
      klonlaoutpusayfa : "Bu çıkışın ikinci konumda hangi sayfada görüntüleneceğini belirler. Aynı çıkış birden fazla yerde gösterilebilir.",
      klonlarowoutput : "Bu çıkışın ikinci konumda hangi satırda yer alacağını belirler. İkinci sayfada farklı bir düzen oluşturabilirsiniz.",
      klonlacolmoutputt : "Bu çıkışın ikinci konumda hangi sütunda yer alacağını belirler. Farklı sayfalarda farklı pozisyonlar seçebilirsiniz." ,
      akımlimitiaçıklama : "Bu çıkışın güvenli (yeşil) bölgede kalması için akım limiti. Bu değer akım limitini geçemez ve güvenlik göstergesi olarak kullanılır.",
      ikonaçıklamaoutput : "Bu çıkış için kullanılacak görsel ikonu seçin. İkon, kullanıcı arayüzünde çıkışı tanımlamak için kullanılır.",
      inputpinaçıklama : "Bu girişin bağlanacağı fiziksel pin numarasını seçin. Her pin sadece bir kez kullanılabilir.",
      enableaçıklama : "Bu girişin aktif olup olmayacağını seçin.",
      vaivenaçıklama : "Bu girişin tetikleyeceği çıkış pin'ini seçin.",
      inğutpageaçıklama : "Bu girişin gösterileceği sayfa numarasını seçin.",
      girişinsıranu : "Bu girişin gösterileceği sıra numarasını seçin.",
      girişinkolonnumarası : "Bu girişin gösterileceği kolon numarasını seçin.",
      panelönizleme : "Panel Önizleme",
      boşslato : "Boş Slot",
      busayfaiçin : "Bu sayfa için kapasite belirlenmemiş",
      sayifaaaapanel : "Sayfa",
      henüzsayfaeklenmemiş : "Henüz sayfa eklenmemiş",
      önizlemeiçinsayfaekleyinkapesite: "Önizleme için önce sayfa ekleyin ve kapasitelerini belirleyin",
      sıraiki : "2. Sıra",
      birincisıra : "1. Sıra",
      bileşentipi : "Bileşen Tipi Seç",
      ssayfa : "Sayfa",
      Sıraaaa:  "Sıra",
      kolloonn : "Kolon",
      eklemekisteidğinizbileşen : "Eklemek istediğiniz bileşen tipini seçin:",
      turuncudalga : "ekleme butonu seçildi. Turuncu butona tıklayın.",
      konfigbulundu : "config bulundu",
      AraçAdı : "Araç Adı",
      sayfaekle  : "Sayfa Ekle",
      aktiftrue : "Evet Aktif",
      aktifalse : "Hayır Aktif Değil",
      versiyonsec : "HMI Yazılım Versiyonunuzu Seçiniz.",
      versiyonusecc : "Versiyon Seçimi",
      devamet : "Devam Et",
      iptalversiyonsecc : "İptal",
      
      bucıkısındimer : "Bu çıkışın dimmer özelliği kullanılacaksa seçin",
      dimmerType : "Dimmer Tipi",
      dimmertipi : "Dimmer Pin",
      sayfaekle : "Sayfa Ekle",
      sayfaayarlarıpanelprewierw : "Sayfa Ayarları",
      kaydetpanelprewiew : "Kaydet",
      iptalpanelprewiew : "İptal",
      sayfadıpanelprewiew : "Sayfa Adı",
      sayfadıgirinpanelprwiew : "Sayfa adını girin",
      birincisırapestasipanelpreewiew : "1. Sıra Kapasitesi",
      birincisırakpesitesizorunlu : "1. sıra kapasitesi zorunludur!",
      değergirinzorunlu : "0-5 arası değer girin!",
      birincisıraiçinkolonsayisi : "1. sıra için kolon sayısı",
      ikincisırakapesitesi : "2. Sıra Kapasitesi",
      ikincisırakpesitesizorunlu : "2. sıra kapasitesi zorunludur!",
      değergirikincipageprewiew : "0-5 arası değer girin!",
      ikincisıraiçinkolonsırayısı : "2. sıra için kolon sayısı",
      pagepreqiew :  "Bu sayfayı silmek istediğinizden emin misiniz?",
      ssilmekteeneminmisinizpalnelprewiewevet: "Evet",
      ssilmekteeneminmisinizpalnelprewiewhayır: "Hayır",
      yenisayfaeklendi : "Yeni sayfa eklendi!",
      birincisırapageprewiew : "1. Sıra:",
      ikincisırapageprewiew : "2. Sıra:",
       // Output validasyonları
  outputPageRequired: "Output {index}: Sayfa seçimi zorunludur",
  outputRowRequired: "Output {index}: Sıra seçimi zorunludur",
  outputColumnRequired: "Output {index}: Kolon seçimi zorunludur",
  outputClonePageRequired: "Output {index}: Clone sayfa seçimi zorunludur",
  outputCloneRowRequired: "Output {index}: Clone sıra seçimi zorunludur",
  outputCloneColumnRequired: "Output {index}: Clone kolon seçimi zorunludur",
  
  // Input validasyonları
  inputPageRequired: "Input {index}: Sayfa seçimi zorunludur",
  inputRowRequired: "Input {index}: Sıra seçimi zorunludur",
  inputColumnRequired: "Input {index}: Kolon seçimi zorunludur",
  inputClonePageRequired: "Input {index}: Clone sayfa seçimi zorunludur",
  inputCloneRowRequired: "Input {index}: Clone sıra seçimi zorunludur",
  inputCloneColumnRequired: "Input {index}: Clone kolon seçimi zorunludur",
  
  // Voltage validasyonları
  voltagePageRequired: "Voltage {index}: Sayfa seçimi zorunludur",
  voltageRowRequired: "Voltage {index}: Sıra seçimi zorunludur",
  voltageColumnRequired: "Voltage {index}: Kolon seçimi zorunludur",
  voltageClonePageRequired: "Voltage {index}: Clone sayfa seçimi zorunludur",
  voltageCloneRowRequired: "Voltage {index}: Clone sıra seçimi zorunludur",
  voltageCloneColumnRequired: "Voltage {index}: Clone kolon seçimi zorunludur",
  
  // Float validasyonları
  floatPageRequired: "Float {index}: Sayfa seçimi zorunludur",
  floatRowRequired: "Float {index}: Sıra seçimi zorunludur",
  floatColumnRequired: "Float {index}: Kolon seçimi zorunludur",
  floatClonePageRequired: "Float {index}: Clone sayfa seçimi zorunludur",
  floatCloneRowRequired: "Float {index}: Clone sıra seçimi zorunludur",
  floatCloneColumnRequired: "Float {index}: Clone kolon seçimi zorunludur",
  configNameRequired: "Konfigürasyon adı boş olamaz!",
  saveStopped: "Kaydetme işlemi durdu. Aşağıdaki hataları düzeltin:",
  saveSuccess: "Konfigürasyon başarıyla kaydedildi!",
  saveError: "Kaydetme sırasında bir hata oluştu!",
  unexpectedError: "Beklenmeyen bir hata oluştu!",
  
  // Relay validasyonları
  relayShortCircuitPinRequired: "Relay {index}: Kısa devre pin seçimi zorunludur",
  relayOpenCircuitPinRequired: "Relay {index}: Açık devre pin seçimi zorunludur",
  relayPinsDifferent: "Relay {index}: Kısa devre ve açık devre pinleri farklı olmalıdır",
  relayShortCircuitVoltageNegative: "Relay {index}: Kısa devre voltajı negatif olamaz",
  relayOpenCircuitVoltageNegative: "Relay {index}: Açık devre voltajı negatif olamaz",
  relayManualOverrideRange: "Relay {index}: Manual override süresi 0-86400 arasında olmalı",
  
  // Output validasyonları
  outputPinRequired: "Output {index}: Pin seçimi zorunludur",
  outputCurrentLimitNegative: "Output {index}: Akım limiti negatif olamaz",
  outputCurrentGreenExceedsLimit: "Output {index}: Akım Yeşil Limiti ({green}A), Akım Limitini ({limit}A) geçemez",
  outputPageExceedsMax: "Output {index}: Sayfa numarası maksimum sayfa sayısını aşamaz ({max})",
  
  // Input validasyonları
  inputPinRequired: "Input {index}: Pin seçimi zorunludur",
  
  // Voltage validasyonları
  voltagePinRequired: "Voltage {index}: Pin seçimi zorunludur",
  
  // Float validasyonları
  floatPinRequired: "Float {index}: Pin seçimi zorunludur",
  floatWarnPercentNegative: "Float {index}: Uyarı yüzdesi negatif olamaz",
  floatErrorPercentNegative: "Float {index}: Hata yüzdesi negatif olamaz",
  floatWaterWarnGreaterError: "Float {index}: Temiz su için uyarı yüzdesi hata yüzdesinden büyük olmalı",
  floatDrainWarnLessError: "Float {index}: Atık/gri su için uyarı yüzdesi hata yüzdesinden küçük olmalı",
  
  // Settings validasyonları
  settingForceShutDownVoltageNegative: "Setting {index}: Zorla kapatma voltajı negatif olamaz",
  settingOptionalDownVoltageNegative: "Setting {index}: Opsiyonel kapatma voltajı negatif olamaz",
  settingStartWarnVoltageNegative: "Setting {index}: Uyarı başlangıç voltajı negatif olamaz",
  settingRecoverVoltageNegative: "Setting {index}: Kurtarma voltajı negatif olamaz",
  settingForceShutDownTimeRange: "Setting {index}: Zorla kapatma süresi 0-600 arasında olmalı",
  
  // Pin ve pozisyon çakışmaları
  pinDuplicate: "Pin {pin} birden fazla yerde kullanılıyor",
  positionDuplicate: "Pozisyon Sayfa {page}, Sıra {row}, Kolon {column} birden fazla yerde kullanılıyor",
  clonePositionDuplicate: "Clone Pozisyon Sayfa {page}, Sıra {row}, Kolon {column} birden fazla yerde kullanılıyor",
  configNameRequired: "Konfigürasyon adı boş olamaz!",
  saveStopped: "Kaydetme işlemi durdu. Aşağıdaki hataları düzeltin:",
  saveSuccess: "Konfigürasyon başarıyla kaydedildi!",
  saveError: "Kaydetme sırasında bir hata oluştu!",
  unexpectedError: "Beklenmeyen bir hata oluştu!",
  outputPinRequired: "Output {index}: Pin seçimi zorunludur",
  inputPinRequired: "Input {index}: Pin seçimi zorunludur",
  voltagePinRequired: "Voltage {index}: Pin seçimi zorunludur",
  floatPinRequired: "Float {index}: Pin seçimi zorunludur",

      maksimumeklenceksayfaondur : "Maksimum 10 sayfa eklenebilir",
      kapesitazaltılamıyor: "Kapasite Azaltılamıyor!",
      kepesitesi : "kapasitesi",
      düşürmelişmiş : "e düşürülemiyor!",
      sayfaymışprew : "Sayfa",
      bupoziyonaatanmış: "📍 Bu pozisyonlarda atanmış itemlar:",
      öncebuitmeleri : "⚠️ Önce bu itemları başka pozisyonlara taşıyın veya silin.",
      anlamışmış : "Anladım",
      Maksimummuşş : "Maksimum kapasite 5'tir!",

      lutfengecerlimail : "Lütfen email giriniz!",
      gecerlibiremail : "Geçerli bir email adresi giriniz!",
      lütfengeçerlişifre : "Lütfen şifrenizi giriniz!",
      girissbasarılı : "Giriş başarılı!",
      grisbasarısızz : "Giriş başarısız. Lütfen bilgilerinizi kontrol ediniz.",
      birhataolustu : "Bir hata oluştu. Lütfen tekrar deneyin.",

      fp_title: "Şifremi Unuttum",
      fp_subtitle: "E-posta adresinize 6 haneli kod gönderilecek",
      fp_emailLabel: "E-posta Adresi",
      fp_emailRequired: "E-posta adresi zorunlu",
      fp_emailInvalid: "Geçerli bir e-posta girin",
      fp_sendCode: "Kod Gönder",
      fp_codeTitle: "Kodu Girin",
      fp_codeSubtitle: "adresine gönderildi · 10 dk geçerli",
      fp_codeLabel: "Doğrulama Kodu",
      fp_codeRequired: "Kod zorunlu",
      fp_codeLength: "6 haneli kodu girin",
      fp_verify: "Kodu Doğrula",
      fp_changeEmail: "Farklı e-posta kullan",
      fp_newPassTitle: "Yeni Şifre Belirle",
      fp_newPassSubtitle: "Güçlü bir şifre seçin",
      fp_newPassLabel: "Yeni Şifre",
      fp_newPassRequired: "Şifre zorunlu",
      fp_newPassMin: "En az 6 karakter olmalı",
      fp_confirmLabel: "Şifre Tekrar",
      fp_confirmRequired: "Şifre tekrar zorunlu",
      fp_confirmMismatch: "Şifreler eşleşmiyor",
      fp_reset: "Şifremi Sıfırla",
      fp_successTitle: "Şifre Sıfırlandı!",
      fp_successSubtitle: "Artık yeni şifrenizle giriş yapabilirsiniz",
      fp_goLogin: "Giriş Yap",
      fp_backToLogin: "Giriş Ekranına Dön",
      fp_stepEmail: "E-posta",
      fp_stepVerify: "Doğrulama",
      fp_stepNewPass: "Yeni Şifre",
      fp_error: "Hata",
      fp_serverError: "Sunucuya bağlanılamadı.",
      fp_link: "Şifremi Unuttum",


      },









    en: {
      lutfengecerlimail : "Please enter your email!",
gecerlibiremail : "Please enter a valid email address!",
lütfengeçerlişifre : "Please enter your password!",
girissbasarılı : "Login successful!",
grisbasarısızz : "Login failed. Please check your information.",
birhataolustu : "An error occurred. Please try again.",

      fp_title: "Forgot Password",
      fp_subtitle: "A 6-digit code will be sent to your email",
      fp_emailLabel: "Email Address",
      fp_emailRequired: "Email address is required",
      fp_emailInvalid: "Enter a valid email",
      fp_sendCode: "Send Code",
      fp_codeTitle: "Enter the Code",
      fp_codeSubtitle: "sent to · valid for 10 min",
      fp_codeLabel: "Verification Code",
      fp_codeRequired: "Code is required",
      fp_codeLength: "Enter the 6-digit code",
      fp_verify: "Verify Code",
      fp_changeEmail: "Use a different email",
      fp_newPassTitle: "Set New Password",
      fp_newPassSubtitle: "Choose a strong password",
      fp_newPassLabel: "New Password",
      fp_newPassRequired: "Password is required",
      fp_newPassMin: "Must be at least 6 characters",
      fp_confirmLabel: "Confirm Password",
      fp_confirmRequired: "Password confirmation is required",
      fp_confirmMismatch: "Passwords do not match",
      fp_reset: "Reset Password",
      fp_successTitle: "Password Reset!",
      fp_successSubtitle: "You can now log in with your new password",
      fp_goLogin: "Log In",
      fp_backToLogin: "Back to Login",
      fp_stepEmail: "Email",
      fp_stepVerify: "Verify",
      fp_stepNewPass: "New Password",
      fp_error: "Error",
      fp_serverError: "Could not connect to server.",
      fp_link: "Forgot Password",
      AraçAdı : "Vehicle Name",
      maksimumeklenceksayfaondur : "Maximum 10 pages can be added",
kapesitazaltılamıyor: "Capacity cannot be reduced!",
kepesitesi : "capacity",
düşürmelişmiş : "cannot be reduced!",
sayfaymışprew : "Page",
bupoziyonaatanmış: "📍 Items assigned to these positions:",
öncebuitmeleri : "⚠️ First move these items to other positions or delete them.",
anlamışmış : "Understood",
Maksimummuşş : "Maximum capacity is 5!",
      outputPinRequired: "Output {index}: Pin selection is required",
  inputPinRequired: "Input {index}: Pin selection is required",
  voltagePinRequired: "Voltage {index}: Pin selection is required",
  floatPinRequired: "Float {index}: Pin selection is required",
        configNameRequired: "Configuration name cannot be empty!",
  saveStopped: "Save operation stopped. Please fix the following errors:",
  saveSuccess: "Configuration saved successfully!",
  saveError: "An error occurred during save!",
  unexpectedError: "An unexpected error occurred!",
      configNameRequired: "Configuration name cannot be empty!",
  saveStopped: "Save operation stopped. Please fix the following errors:",
  saveSuccess: "Configuration saved successfully!",
  saveError: "An error occurred during save!",
  unexpectedError: "An unexpected error occurred!",
  
  // Relay validations
  relayShortCircuitPinRequired: "Relay {index}: Short circuit pin selection is required",
  relayOpenCircuitPinRequired: "Relay {index}: Open circuit pin selection is required",
  relayPinsDifferent: "Relay {index}: Short circuit and open circuit pins must be different",
  relayShortCircuitVoltageNegative: "Relay {index}: Short circuit voltage cannot be negative",
  relayOpenCircuitVoltageNegative: "Relay {index}: Open circuit voltage cannot be negative",
  relayManualOverrideRange: "Relay {index}: Manual override duration must be between 0-86400",
  
  // Output validations
  outputPinRequired: "Output {index}: Pin selection is required",
  outputCurrentLimitNegative: "Output {index}: Current limit cannot be negative",
  outputCurrentGreenExceedsLimit: "Output {index}: Current Green Limit ({green}A) cannot exceed Current Limit ({limit}A)",
  outputPageExceedsMax: "Output {index}: Page number cannot exceed maximum page count ({max})",
  
  // Input validations
  inputPinRequired: "Input {index}: Pin selection is required",
  
  // Voltage validations
  voltagePinRequired: "Voltage {index}: Pin selection is required",
  
  // Float validations
  floatPinRequired: "Float {index}: Pin selection is required",
  floatWarnPercentNegative: "Float {index}: Warning percentage cannot be negative",
  floatErrorPercentNegative: "Float {index}: Error percentage cannot be negative",
  floatWaterWarnGreaterError: "Float {index}: Warning percentage must be greater than error percentage for clean water",
  floatDrainWarnLessError: "Float {index}: Warning percentage must be less than error percentage for drain/gray water",
  
  // Settings validations
  settingForceShutDownVoltageNegative: "Setting {index}: Force shutdown voltage cannot be negative",
  settingOptionalDownVoltageNegative: "Setting {index}: Optional shutdown voltage cannot be negative",
  settingStartWarnVoltageNegative: "Setting {index}: Warning start voltage cannot be negative",
  settingRecoverVoltageNegative: "Setting {index}: Recovery voltage cannot be negative",
  settingForceShutDownTimeRange: "Setting {index}: Force shutdown time must be between 0-600",
  
  // Pin and position conflicts
  pinDuplicate: "Pin {pin} is used in multiple places",
  positionDuplicate: "Position Page {page}, Row {row}, Column {column} is used in multiple places",
  clonePositionDuplicate: "Clone Position Page {page}, Row {row}, Column {column} is used in multiple places",
      // Output validations
  outputPageRequired: "Output {index}: Page selection is required",
  outputRowRequired: "Output {index}: Row selection is required",
  outputColumnRequired: "Output {index}: Column selection is required",
  outputClonePageRequired: "Output {index}: Clone page selection is required",
  outputCloneRowRequired: "Output {index}: Clone row selection is required",
  outputCloneColumnRequired: "Output {index}: Clone column selection is required",
  
  // Input validations
  inputPageRequired: "Input {index}: Page selection is required",
  inputRowRequired: "Input {index}: Row selection is required",
  inputColumnRequired: "Input {index}: Column selection is required",
  inputClonePageRequired: "Input {index}: Clone page selection is required",
  inputCloneRowRequired: "Input {index}: Clone row selection is required",
  inputCloneColumnRequired: "Input {index}: Clone column selection is required",
  
  // Voltage validations
  voltagePageRequired: "Voltage {index}: Page selection is required",
  voltageRowRequired: "Voltage {index}: Row selection is required",
  voltageColumnRequired: "Voltage {index}: Column selection is required",
  voltageClonePageRequired: "Voltage {index}: Clone page selection is required",
  voltageCloneRowRequired: "Voltage {index}: Clone row selection is required",
  voltageCloneColumnRequired: "Voltage {index}: Clone column selection is required",
  
  // Float validations
  floatPageRequired: "Float {index}: Page selection is required",
  floatRowRequired: "Float {index}: Row selection is required",
  floatColumnRequired: "Float {index}: Column selection is required",
  floatClonePageRequired: "Float {index}: Clone page selection is required",
  floatCloneRowRequired: "Float {index}: Clone row selection is required",
  floatCloneColumnRequired: "Float {index}: Clone column selection is required",
      bucıkısındimer : "Select if the dimmer feature of this output will be used",
dimmerType : "Dimmer Type",
dimmertipi : "Dimmer Pin",
sayfaekle : "Add Page",
sayfaayarlarıpanelprewierw : "Page Settings",
kaydetpanelprewiew : "Save",
iptalpanelprewiew : "Cancel",
sayfadıpanelprewiew : "Page Name",
sayfadıgirinpanelprwiew : "Enter page name",
birincisırapestasipanelpreewiew : "1st Row Capacity",
birincisırakpesitesizorunlu : "1st row capacity is required!",
değergirinzorunlu : "Enter a value between 0 and 5!",
birincisıraiçinkolonsayisi : "Number of columns for the 1st row",
ikincisırakapesitesi : "2nd Row Capacity",
ikincisırakpesitesizorunlu : "2nd row capacity is required!",
değergirikincipageprewiew : "Enter a value between 0 and 5!",
ikincisıraiçinkolonsırayısı : "Number of columns for the 2nd row",
pagepreqiew : "Are you sure you want to delete this page?",
ssilmekteeneminmisinizpalnelprewiewevet : "Yes",
ssilmekteeneminmisinizpalnelprewiewhayır : "No",
yenisayfaeklendi : "New page added!",
birincisırapageprewiew : "1st Row:",
ikincisırapageprewiew : "2nd Row:",
      versiyonsec : "Select Your HMI Software Version.",
versiyonusecc : "Version Selection",
devamet : "Continue",
iptalversiyonsecc : "Cancel",
      bileşentipi : "Select Component Type",
      ssayfa : "Page",
      Sıraaaa:  "Order",
      kolloonn : "Column",
      eklemekisteidğinizbileşen : "Select the component type you want to add:",
      turuncudalga : "add button selected. Click the orange button.",
      konfigbulundu : "config found",
      panelönizleme : "Panel Preview",
      boşslato : "Empty Slot",
      busayfaiçin : "No capacity set for this page",
      sayifaaaapanel : "Page",
      henüzsayfaeklenmemiş : "No page added yet",
      önizlemeiçinsayfaekleyinkapesite: "First add pages and set their capacities for preview",
      sıraiki : "2nd Row",
      birincisıra : "1st Row",
      açıklamatürkçe : "This name will be displayed when Turkish is selected in the user interface.",
      açılamaIngülüzce : "This name will be displayed when English is selected in the user interface.",
      açıklamaalmanca : "This name will be displayed when German is selected in the user interface.",

      klonlasayfa : "Select the page number to be displayed in the second location.",
      klonlasıranumarası : "Select the row number to be displayed in the second location.",
      klonladasırakolonnumarası : "Select the column number to be displayed in the second location.",

      İkonaçıklama : "Select the icon to be used.",

      voltagepinaçıklama : "Select the physical pin number to which this voltage sensor will be connected. Each pin can only be used once.",
      voltagenableaçıklama : "Select whether this voltage sensor will be active or not.",
      pagevoltajaçıklama : "Select the page number on which this voltage sensor will be displayed.",
      voltajaçıklamaymış : "Select the row number on which this voltage sensor will be displayed.",
      voltajsensörükolonnum : "Select the column number on which this voltage sensor will be displayed.",
      şamandırapinaçıklama : "Select the physical pin number to which this float sensor will be connected. Each pin can only be used once.",
      enableaçıklamamyşs : "Select whether this float sensor will be active or not.",
      sensörtüpaçıklaama : "Select the type of float sensor.",
      purpeseeaçıklamaa : "Select the purpose of this float sensor (water, waste water, or gray water).",
      uyarıverecekaçıklama : "Enter the percentage level at which a warning will be given.",
      errorpensentaçıklama : "Enter the percentage level at which an error will be given.",
      lokpinaçıklama : "Select the lock pin connected to this float sensor.",
      şamandırasayfanum : "Select the page number on which this float sensor will be displayed.",
      şamandırasıranumarası : "Select the row number on which this float sensor will be displayed.",
      kollonumarasışamadnıra : "Select the column number on which this float sensor will be displayed.",

      röleaçıkalmalat : "Determines the active or passive state of the relay. When active, the relay can operate.",
      şortkatbirşeymişney : "Physical pin number to be used for short circuit condition. Each pin can only be used once.",
      açıkdevrebirşeymişneymişondan : "Physical pin number to be used for open circuit condition. Each pin can only be used once.",
      kısadevredurumdauygulanacak : "Voltage value to be applied in short circuit condition (in Volts). Values between 8V and 100V can be entered.",
      açıkdevredurumuaçıklama : "Voltage value to be applied in open circuit condition (in Volts). Values between 8V and 100V can be entered.",
      manuelmüdahalesanresi : "Manual intervention time (in seconds). Values between 0 and 86400 seconds (24 hours) can be entered.",
      sistemizrlakapat : "Critical low voltage value at which the system will forcibly shut down. When it falls below this value, the system automatically shuts down for safety.",
      sistemizorlakapatmavoltaj : "Optional shutdown voltage. When this value is reached, the system can be shut down according to user preference.",
      uyarıbaşlatmavoltajı : "Warning start voltage. When it falls below this value, the system starts giving low battery warnings.",
      kurtarmavoltajıaçıklama : "Recovery voltage. When the system reaches this voltage value, it returns to normal operating mode and warnings are turned off.",
      zorlakapatmaaçıklama : "Forced shutdown time. Time to wait for system shutdown after reaching critical voltage level (in seconds).",
      sıcaklıksensörüaktifpasif : "Determines the active/passive state of the temperature sensor. When active, the sensor takes measurements.",
      sıcaklsısensörükonum : "Determines the placement location of the temperature sensor (right or left side).",
      sıcaklıksensörüikon : "Visual icon selection for temperature sensor. Determines the symbol that will represent the sensor in the interface.",

      rowKapesite : "Determines the maximum number of items to be displayed in the first row. This value affects the visual layout and content capacity of the page.",
      rowkapesite2 : "Determines the maximum number of items to be displayed in the second row. If left empty, the second row is not used and is hidden.",
      benzersizIsim : "Define a unique name for this page. This name will be used for navigation and management purposes.",
      outputPinAcıklama : "Select the physical pin number to which this output will be connected. Each pin can only be used once and must not conflict with other outputs.",
      röleAcıklama : "Determines the operating type of the output. Disabled: Disabled, Enabled: Active, Fix: Fixed operation, Relay: Relay control",
      currenlimitacıklama : "Determines the maximum current limit of this output (in Amperes). This value should not be exceeded for safety.",
      outputSayfa : "Determines on which page this output will be displayed. Used to organize between pages.",
      outuptSatır : "Determines in which row this output will be placed on the page. Page must be selected first.",
      stunoutput : "Determines in which column this output will be placed in the selected row. Page and row must be selected first.",
      klonlaoutpusayfa : "Determines on which page this output will be displayed in the second location. The same output can be shown in multiple places.",
      klonlarowoutput : "Determines in which row this output will be placed in the second location. You can create a different layout on the second page.",
      klonlacolmoutputt : "Determines in which column this output will be placed in the second location. You can select different positions on different pages.",

      akımlimitiaçıklama : "Current limit for this output to remain in the safe (green) zone. This value cannot exceed the current limit and is used as a safety indicator.",
      ikonaçıklamaoutput : "Select the visual icon to be used for this output. The icon is used to identify the output in the user interface.",
      
      inputpinaçıklama : "Select the physical pin number to which this input will be connected. Each pin can only be used once.",
      enableaçıklama : "Select whether this input will be active or not.",
      vaivenaçıklama : "Select the output pin that this input will trigger.",
      inğutpageaçıklama : "Select the page number on which this input will be displayed.",
      girişinsıranu : "Select the row number on which this input will be displayed.",
      girişinkolonnumarası : "Select the column number on which this input will be displayed.",
      succes : "Successful",
      removeFilses : "Delete File",
      showFiles : "View File",
      fileOperation: "File Operations",
      temprature : "Temperature",  
      numberOfTemprature : "Number",  
      isTempratureEnable : "Temperature Enable",  
      location : "Location",  
      right : "Right",  
      left : "Left",
      profilbg: "Profile updated successfully.",
      profilbas: "Update failed.",
      bhataol: "An error occurred.",
      profbilgi: "Profile Information",
      update: "Update",
      kaara : "Search by configuration name",
      kag : "Configuration name.",
      negatifdg: "You cannot enter a negative value.",
      tsuiuy: "The warning percentage for clean water must be greater than the error percentage.",
      kgsiu: "The warning percentage for dirty/grey water must be less than the error percentage.",
      exit: "Log Out",
      profile: "My Profile",
      konfig: "My Configurations",
      ukb: "User Configuration Information",
      ub: "User Information",
      kyt: "User Help Requests",
      layoutTitle: "Octoopi Van Configurator",
      layoutFooter: "© 2024 Octoopi Systems",
      pages: "Pages",
      outputs: "Outputs",
      addPage: "Add Page",
      addOutput: "Add Output",
      deleteConfirm: "Are you sure you want to delete this item?",
      yes: "Yes",
      no: "No",
      saveChanges: "Save Changes and Download",
      firstRowCapacity: "First Row Capacity",
      secondRowCapacity: "Second Row Capacity",
      pageAlias: "Page Alias",
      socketpin: "Socketpin",
      type: "Type",
      currentLimit: "Current Limit (A)",
      page: "Page",
      column: "Column",
      row: "Row",
      clone: "Clone",
      currentGreenLimit: "Current Green Limit (A)",
      icon: "Icon",
      nameTR: "Name (TR)",
      nameGB: "Name (GB)",
      nameDE: "Name (DE)",
      delete: "Delete",
      dkvi: "Save and Download Changes",
      forceShutDownVoltage: "Force shutdown voltage (V)",
      optionalDownVoltage: "Optional shutdown voltage",
      startWarnVoltage: "Start warning voltage (V)",
      recoverVoltage: "Recovery voltage",
      forceShutDownTime: "Force shutdown time (seconds)",
      setting: "Setting",
      shortCircuitSocketpin: "Short circuit socket pin",
      openCircuitSocketpin: "Open circuit socket pin",
      shortCircuitVoltage: "Short circuit voltage (V)",
      openCircuitVoltage: "Open circuit voltage (V)",
      manualOverrideDuration: "Manual override duration (seconds)",
      relay: "Relay",
      active: "Aktive",
      floats: "Floats",
      voltages : "Voltages",
      inputs: "Inputs",
      addInput: "Add Input",
      addVoltage: "Add Voltage",
      addFloat: "Add Float",
      empty: "Empty",
      water: "Water",
      drain: "Drain",
      gray: "Gray",
      purpose: "Purpose",
      warnPercent: "Warn Percent",
      errorPercent: "Error Percent",
      lock_pin: "Lock Pin",
      enable: "Enable",
      vavienOutput: "Vavien Output",
      disabled: "Disabled",
      enabled: "Enabled",
      Fix: "Fix",
      selectIcon: "Select Icon",
      deleteClone:"Delete Clone",
      page2: "Page 2",
      column2: "Column 2",
      row2: "Row 2",
      optional: "Optional",
      companyName: "Company Name",
      caravanType: "Caravan Type",
      description: "Description",
      customerNameSurname: "Customer Name Surname",
      customerPhone: "Customer Phone",
      customerCountry: "Customer Country",
      customerInformation : "Customer Information",
      howUsing: "How to Use?",
      adminLogin: "Admin Login",
      oneContent: "The B and S series, which are the most basic products of the Octoopi Van series, offer caravan users the comfort of obtaining information about the living space. Our products consist of two parts: a touchscreen user interface and a power control module, with two screen size options: 4.3 and 7 inches. Thanks to the advanced interface and technological power control unit, users can access all necessary information with the B and S series. With its MultiColor and Glass+Glass capacitive touchscreen, it offers a smartphone-like user experience. Featuring semiconductor power drivers and digital/analog inputs, we present you a smart system through the Octoopi Van Series. Designed and manufactured locally, Octoopi also ensures high customer satisfaction with installation and technical support services after sales.",
      requestHelp: "Request Help",
      areaRequired: "This field is required.",
      titile: "Title",
      plaseEnter: "Please enter your email address so we can contact you.",
      helpReq: "Write the details of your help request here...",
      sendRequest: "Send Request",
      outputPin : "Output Pin",
      inputPin: "Input Pin",
      voltagesPin : "Voltage Pin",
      floatsPin : "Float Pin",
      outputName : "Output",
      inputName : "Input",
      voltageName : "Voltage",
      floatName : "Float",
      sgy: "Login to System",
      email: "Email Address",
      password: "Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordMismatch: "Passwords do not match!",
      passwordUpdateTitle: "Update Password",
      passwordSuccess: "Password updated successfully.",
      gy: "Log In",
      hym: "Don't have an account?",
      ho: "Create an account",
      sgyö: "Before logging in to the system",
      kog: "you need to register.",
      ehv: "If you already have an account",
      sükgy: "you can log in from the top corner.",
      kf: "User Form",
      name: "First Name",
      surname: "Last Name",
      fa: "Company Name",
      kt: "Caravan Type",
      description: "Description",
      customerPhone: "Customer Phone",
      country: "Country",
      submit: "Register",
      login: "Login",
      yke: "Add New Configuration",
      kdi: "Download Configuration File",
      ot: "Created At",
      gt: "Updated At",
      dowland: "Download",
      nk: "How To Use",
      sae: "1. Pages Screen",
      sefeat: "The pages screen represents different UI pages. You can duplicate up to 10 pages. During configuration you set the capacity of these pages. Each page can hold a maximum of 5 and a minimum of 0 icons. Completing this step is required first.",
      içç: "2. Outputs",
      bepy: "In this screen, output pins are configured. Current limit and pin are set. Current Limit: The maximum current value. Green Current Limit: The minimum current at which the device operates normally. To enable the output, set type to “active”.",
      titlee: "Title",
      mail: "E-Mail",
      description: "Description",
      tb: "Send Request",
      ytb: "Submit a Support Request",
      ytb : "Request Help",
      search : "Search",
      clean : "Clear",
      yb : "Help Title",
      ya : "Help Description",
      km : "User Email",
      kl : "List Configurations", 
      ci : "Download Config",
      cid: "Config Id",
      ka : "Username",
      mid : "Customer Id",
      kaa : "Search Username",
      mia : "Search Customer Id",
      adi : "First Name",
      soyadi : "Last Name",
      işlem : "Action",
      aylalg : "Current Green Limit Cannot Exceed Current Limit!"
    },











    de: {
      lutfengecerlimail : "Bitte geben Sie Ihre E-Mail-Adresse ein!",
gecerlibiremail : "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
lütfengeçerlişifre : "Bitte geben Sie Ihr Passwort ein!",
girissbasarılı : "Anmeldung erfolgreich!",
grisbasarısızz : "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Angaben.",
birhataolustu : "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",

      fp_title: "Passwort vergessen",
      fp_subtitle: "Ein 6-stelliger Code wird an Ihre E-Mail gesendet",
      fp_emailLabel: "E-Mail-Adresse",
      fp_emailRequired: "E-Mail-Adresse ist erforderlich",
      fp_emailInvalid: "Gültige E-Mail eingeben",
      fp_sendCode: "Code senden",
      fp_codeTitle: "Code eingeben",
      fp_codeSubtitle: "gesendet an · 10 Min. gültig",
      fp_codeLabel: "Bestätigungscode",
      fp_codeRequired: "Code ist erforderlich",
      fp_codeLength: "6-stelligen Code eingeben",
      fp_verify: "Code bestätigen",
      fp_changeEmail: "Andere E-Mail verwenden",
      fp_newPassTitle: "Neues Passwort festlegen",
      fp_newPassSubtitle: "Wählen Sie ein sicheres Passwort",
      fp_newPassLabel: "Neues Passwort",
      fp_newPassRequired: "Passwort ist erforderlich",
      fp_newPassMin: "Mindestens 6 Zeichen erforderlich",
      fp_confirmLabel: "Passwort bestätigen",
      fp_confirmRequired: "Passwortbestätigung ist erforderlich",
      fp_confirmMismatch: "Passwörter stimmen nicht überein",
      fp_reset: "Passwort zurücksetzen",
      fp_successTitle: "Passwort zurückgesetzt!",
      fp_successSubtitle: "Sie können sich jetzt mit Ihrem neuen Passwort anmelden",
      fp_goLogin: "Anmelden",
      fp_backToLogin: "Zurück zum Login",
      fp_stepEmail: "E-Mail",
      fp_stepVerify: "Bestätigung",
      fp_stepNewPass: "Neues Passwort",
      fp_error: "Fehler",
      fp_serverError: "Verbindung zum Server nicht möglich.",
      fp_link: "Passwort vergessen",
       AraçAdı : "Fahrzeugname",
      maksimumeklenceksayfaondur : "Es können maximal 10 Seiten hinzugefügt werden",
kapesitazaltılamıyor: "Kapazität kann nicht verringert werden!",
kepesitesi : "Kapazität",
düşürmelişmiş : "kann nicht verringert werden!",
sayfaymışprew : "Seite",
bupoziyonaatanmış: "📍 Den folgenden Positionen zugewiesene Elemente:",
öncebuitmeleri : "⚠️ Verschieben Sie diese Elemente zuerst in andere Positionen oder löschen Sie sie.",
anlamışmış : "Verstanden",
Maksimummuşş : "Maximale Kapazität ist 5!",
      outputPinRequired: "Output {index}: Pin-Auswahl ist erforderlich",
  inputPinRequired: "Input {index}: Pin-Auswahl ist erforderlich",
  voltagePinRequired: "Voltage {index}: Pin-Auswahl ist erforderlich",
  floatPinRequired: "Float {index}: Pin-Auswahl ist erforderlich",
        configNameRequired: "Konfigurationsname darf nicht leer sein!",
  saveStopped: "Speichervorgang gestoppt. Bitte beheben Sie die folgenden Fehler:",
  saveSuccess: "Konfiguration erfolgreich gespeichert!",
  saveError: "Beim Speichern ist ein Fehler aufgetreten!",
  unexpectedError: "Ein unerwarteter Fehler ist aufgetreten!",
      configNameRequired: "Konfigurationsname darf nicht leer sein!",
  saveStopped: "Speichervorgang gestoppt. Bitte beheben Sie die folgenden Fehler:",
  saveSuccess: "Konfiguration erfolgreich gespeichert!",
  saveError: "Beim Speichern ist ein Fehler aufgetreten!",
  unexpectedError: "Ein unerwarteter Fehler ist aufgetreten!",
  
  // Relais-Validierungen
  relayShortCircuitPinRequired: "Relais {index}: Kurzschluss-Pin-Auswahl ist erforderlich",
  relayOpenCircuitPinRequired: "Relais {index}: Offener Stromkreis-Pin-Auswahl ist erforderlich",
  relayPinsDifferent: "Relais {index}: Kurzschluss- und offener Stromkreis-Pins müssen unterschiedlich sein",
  relayShortCircuitVoltageNegative: "Relais {index}: Kurzschlussspannung darf nicht negativ sein",
  relayOpenCircuitVoltageNegative: "Relais {index}: Offene Stromkreisspannung darf nicht negativ sein",
  relayManualOverrideRange: "Relais {index}: Manuelle Überschreibungsdauer muss zwischen 0-86400 liegen",
  
  // Output-Validierungen
  outputPinRequired: "Output {index}: Pin-Auswahl ist erforderlich",
  outputCurrentLimitNegative: "Output {index}: Stromgrenze darf nicht negativ sein",
  outputCurrentGreenExceedsLimit: "Output {index}: Grüne Stromgrenze ({green}A) darf Stromgrenze ({limit}A) nicht überschreiten",
  outputPageExceedsMax: "Output {index}: Seitennummer darf maximale Seitenanzahl ({max}) nicht überschreiten",
  
  // Input-Validierungen
  inputPinRequired: "Input {index}: Pin-Auswahl ist erforderlich",
  
  // Spannungs-Validierungen
  voltagePinRequired: "Voltage {index}: Pin-Auswahl ist erforderlich",
  
  // Float-Validierungen
  floatPinRequired: "Float {index}: Pin-Auswahl ist erforderlich",
  floatWarnPercentNegative: "Float {index}: Warnprozentsatz darf nicht negativ sein",
  floatErrorPercentNegative: "Float {index}: Fehlerprozentsatz darf nicht negativ sein",
  floatWaterWarnGreaterError: "Float {index}: Warnprozentsatz muss für sauberes Wasser größer als Fehlerprozentsatz sein",
  floatDrainWarnLessError: "Float {index}: Warnprozentsatz muss für Abwasser/Grauwasser kleiner als Fehlerprozentsatz sein",
  
  // Einstellungs-Validierungen
  settingForceShutDownVoltageNegative: "Einstellung {index}: Zwangsabschaltspannung darf nicht negativ sein",
  settingOptionalDownVoltageNegative: "Einstellung {index}: Optionale Abschaltspannung darf nicht negativ sein",
  settingStartWarnVoltageNegative: "Einstellung {index}: Warnstartspannung darf nicht negativ sein",
  settingRecoverVoltageNegative: "Einstellung {index}: Wiederherstellungsspannung darf nicht negativ sein",
  settingForceShutDownTimeRange: "Einstellung {index}: Zwangsabschaltzeit muss zwischen 0-600 liegen",
  
  // Pin- und Positionskonflikte
  pinDuplicate: "Pin {pin} wird an mehreren Stellen verwendet",
  positionDuplicate: "Position Seite {page}, Zeile {row}, Spalte {column} wird an mehreren Stellen verwendet",
  clonePositionDuplicate: "Klon-Position Seite {page}, Zeile {row}, Spalte {column} wird an mehreren Stellen verwendet",
      // Output-Validierungen
  outputPageRequired: "Output {index}: Seitenauswahl ist erforderlich",
  outputRowRequired: "Output {index}: Zeilenauswahl ist erforderlich",
  outputColumnRequired: "Output {index}: Spaltenauswahl ist erforderlich",
  outputClonePageRequired: "Output {index}: Klon-Seitenauswahl ist erforderlich",
  outputCloneRowRequired: "Output {index}: Klon-Zeilenauswahl ist erforderlich",
  outputCloneColumnRequired: "Output {index}: Klon-Spaltenauswahl ist erforderlich",
  
  // Input-Validierungen
  inputPageRequired: "Input {index}: Seitenauswahl ist erforderlich",
  inputRowRequired: "Input {index}: Zeilenauswahl ist erforderlich",
  inputColumnRequired: "Input {index}: Spaltenauswahl ist erforderlich",
  inputClonePageRequired: "Input {index}: Klon-Seitenauswahl ist erforderlich",
  inputCloneRowRequired: "Input {index}: Klon-Zeilenauswahl ist erforderlich",
  inputCloneColumnRequired: "Input {index}: Klon-Spaltenauswahl ist erforderlich",
  
  // Voltage-Validierungen
  voltagePageRequired: "Voltage {index}: Seitenauswahl ist erforderlich",
  voltageRowRequired: "Voltage {index}: Zeilenauswahl ist erforderlich",
  voltageColumnRequired: "Voltage {index}: Spaltenauswahl ist erforderlich",
  voltageClonePageRequired: "Voltage {index}: Klon-Seitenauswahl ist erforderlich",
  voltageCloneRowRequired: "Voltage {index}: Klon-Zeilenauswahl ist erforderlich",
  voltageCloneColumnRequired: "Voltage {index}: Klon-Spaltenauswahl ist erforderlich",
  
  // Float-Validierungen
  floatPageRequired: "Float {index}: Seitenauswahl ist erforderlich",
  floatRowRequired: "Float {index}: Zeilenauswahl ist erforderlich",
  floatColumnRequired: "Float {index}: Spaltenauswahl ist erforderlich",
  floatClonePageRequired: "Float {index}: Klon-Seitenauswahl ist erforderlich",
  floatCloneRowRequired: "Float {index}: Klon-Zeilenauswahl ist erforderlich",
  floatCloneColumnRequired: "Float {index}: Klon-Spaltenauswahl ist erforderlich",
      bucıkısındimer : "Wählen Sie diese Option, wenn die Dimmerfunktion dieses Ausgangs verwendet werden soll",
dimmerType : "Dimmertyp",
dimmertipi : "Dimmer-Pin",
sayfaekle : "Seite hinzufügen",
sayfaayarlarıpanelprewierw : "Seiteneinstellungen",
kaydetpanelprewiew : "Speichern",
iptalpanelprewiew : "Abbrechen",
sayfadıpanelprewiew : "Seitenname",
sayfadıgirinpanelprwiew : "Seitennamen eingeben",
birincisırapestasipanelpreewiew : "Kapazität der 1. Reihe",
birincisırakpesitesizorunlu : "Die Kapazität der 1. Reihe ist erforderlich!",
değergirinzorunlu : "Geben Sie einen Wert zwischen 0 und 5 ein!",
birincisıraiçinkolonsayisi : "Anzahl der Spalten für die 1. Reihe",
ikincisırakapesitesi : "Kapazität der 2. Reihe",
ikincisırakpesitesizorunlu : "Die Kapazität der 2. Reihe ist erforderlich!",
değergirikincipageprewiew : "Geben Sie einen Wert zwischen 0 und 5 ein!",
ikincisıraiçinkolonsırayısı : "Anzahl der Spalten für die 2. Reihe",
pagepreqiew : "Möchten Sie diese Seite wirklich löschen?",
ssilmekteeneminmisinizpalnelprewiewevet : "Ja",
ssilmekteeneminmisinizpalnelprewiewhayır : "Nein",
yenisayfaeklendi : "Neue Seite hinzugefügt!",
birincisırapageprewiew : "1. Reihe:",
ikincisırapageprewiew : "2. Reihe:",
      versiyonsec : "Wählen Sie Ihre HMI-Softwareversion aus.",
versiyonusecc : "Versionsauswahl",
devamet : "Weiter",
iptalversiyonsecc : "Abbrechen",
      bileşentipi : "Komponenttyp auswählen",
      ssayfa : "Seite",
      Sıraaaa:  "Reihenfolge",
      kolloonn : "Spalte",
      eklemekisteidğinizbileşen : "Wählen Sie den Komponententyp aus, den Sie hinzufügen möchten:",
      turuncudalga : "Hinzufügen-Button ausgewählt. Klicken Sie auf den orangefarbenen Button.",
      konfigbulundu : "Konfiguration gefunden",
            panelönizleme : "Panel-Vorschau",
      boşslato : "Leerer Slot",
      busayfaiçin : "Keine Kapazität für diese Seite festgelegt",
      sayifaaaapanel : "Seite",
      henüzsayfaeklenmemiş : "Noch keine Seite hinzugefügt",
      önizlemeiçinsayfaekleyinkapesite: "Fügen Sie zuerst Seiten hinzu und legen Sie deren Kapazitäten für die Vorschau fest",
      sıraiki : "2. Reihe",
      birincisıra : "1. Reihe",
      açıklamatürkçe : "Dieser Name wird angezeigt, wenn Türkisch in der Benutzeroberfläche ausgewählt wird.",
      açılamaIngülüzce : "Dieser Name wird angezeigt, wenn Englisch in der Benutzeroberfläche ausgewählt wird.",
      açıklamaalmanca : "Dieser Name wird angezeigt, wenn Deutsch in der Benutzeroberfläche ausgewählt wird.",

      klonlasayfa : "Wählen Sie die Seitenzahl aus, die an der zweiten Position angezeigt werden soll.",
      klonlasıranumarası : "Wählen Sie die Zeilennummer aus, die an der zweiten Position angezeigt werden soll.",
      klonladasırakolonnumarası : "Wählen Sie die Spaltennummer aus, die an der zweiten Position angezeigt werden soll.",

      İkonaçıklama : "Wählen Sie das zu verwendende Symbol aus.",

      voltagepinaçıklama : "Wählen Sie die physische Pin-Nummer aus, an die dieser Spannungssensor angeschlossen wird. Jeder Pin kann nur einmal verwendet werden.",
      voltagenableaçıklama : "Wählen Sie aus, ob dieser Spannungssensor aktiv sein soll oder nicht.",
      pagevoltajaçıklama : "Wählen Sie die Seitenzahl aus, auf der dieser Spannungssensor angezeigt werden soll.",
      voltajaçıklamaymış : "Wählen Sie die Zeilennummer aus, auf der dieser Spannungssensor angezeigt werden soll.",
      voltajsensörükolonnum : "Wählen Sie die Spaltennummer aus, auf der dieser Spannungssensor angezeigt werden soll.",
      şamandırapinaçıklama : "Wählen Sie die physische Pin-Nummer aus, an die dieser Schwimmerschalter angeschlossen wird. Jeder Pin kann nur einmal verwendet werden.",
      enableaçıklamamyşs : "Wählen Sie aus, ob dieser Schwimmerschalter aktiv sein soll oder nicht.",
      sensörtüpaçıklaama : "Wählen Sie den Typ des Schwimmerschalters aus.",
      purpeseeaçıklamaa : "Wählen Sie den Zweck dieses Schwimmerschalters aus (Wasser, Abwasser oder Grauwasser).",
      uyarıverecekaçıklama : "Geben Sie den Prozentsatz ein, bei dem eine Warnung ausgegeben wird.",
      errorpensentaçıklama : "Geben Sie den Prozentsatz ein, bei dem ein Fehler ausgegeben wird.",
      lokpinaçıklama : "Wählen Sie den Sperrpin aus, der mit diesem Schwimmerschalter verbunden ist.",
      şamandırasayfanum : "Wählen Sie die Seitenzahl aus, auf der dieser Schwimmerschalter angezeigt werden soll.",
      şamandırasıranumarası : "Wählen Sie die Zeilennummer aus, auf der dieser Schwimmerschalter angezeigt werden soll.",
      kollonumarasışamadnıra : "Wählen Sie die Spaltennummer aus, auf der dieser Schwimmerschalter angezeigt werden soll.",

      röleaçıkalmalat : "Bestimmt den aktiven oder passiven Zustand des Relais. Wenn aktiv, kann das Relais betrieben werden.",
      şortkatbirşeymişney : "Physische Pin-Nummer für Kurzschlusszustand. Jeder Pin kann nur einmal verwendet werden.",
      açıkdevrebirşeymişneymişondan : "Physische Pin-Nummer für offenen Stromkreiszustand. Jeder Pin kann nur einmal verwendet werden.",
      kısadevredurumdauygulanacak : "Spannungswert bei Kurzschlusszustand (in Volt). Werte zwischen 8V und 100V können eingegeben werden.",
      açıkdevredurumuaçıklama : "Spannungswert bei offenem Stromkreiszustand (in Volt). Werte zwischen 8V und 100V können eingegeben werden.",
      manuelmüdahalesanresi : "Manuelle Eingriffszeit (in Sekunden). Werte zwischen 0 und 86400 Sekunden (24 Stunden) können eingegeben werden.",
      sistemizrlakapat : "Kritischer niedriger Spannungswert, bei dem das System zwangsweise heruntergefahren wird. Wenn es unter diesen Wert fällt, schaltet sich das System automatisch aus Sicherheitsgründen ab.",
      sistemizorlakapatmavoltaj : "Optionale Abschaltspannung. Wenn dieser Wert erreicht wird, kann das System nach Benutzerpräferenz abgeschaltet werden.",
      uyarıbaşlatmavoltajı : "Warnstartspannung. Wenn es unter diesen Wert fällt, beginnt das System mit der Ausgabe von Batteriewarnungen.",
      kurtarmavoltajıaçıklama : "Wiederherstellungsspannung. Wenn das System diesen Spannungswert erreicht, kehrt es zum normalen Betriebsmodus zurück und Warnungen werden ausgeschaltet.",
      zorlakapatmaaçıklama : "Zwangsabschaltzeit. Wartezeit für das Herunterfahren des Systems nach Erreichen des kritischen Spannungsniveaus (in Sekunden).",
      sıcaklıksensörüaktifpasif : "Bestimmt den aktiven/passiven Zustand des Temperatursensors. Wenn aktiv, nimmt der Sensor Messungen vor.",
      sıcaklsısensörükonum : "Bestimmt die Platzierungsposition des Temperatursensors (rechte oder linke Seite).",
      sıcaklıksensörüikon : "Visuelle Symbolauswahl für Temperatursensor. Bestimmt das Symbol, das den Sensor in der Benutzeroberfläche repräsentiert.",

      rowKapesite : "Bestimmt die maximale Anzahl der Elemente, die in der ersten Zeile angezeigt werden. Dieser Wert beeinflusst das visuelle Layout und die Inhaltskapazität der Seite.",
      rowkapesite2 : "Bestimmt die maximale Anzahl der Elemente, die in der zweiten Zeile angezeigt werden. Wenn leer gelassen, wird die zweite Zeile nicht verwendet und ausgeblendet.",
      benzersizIsim : "Definieren Sie einen eindeutigen Namen für diese Seite. Dieser Name wird für Navigations- und Verwaltungszwecke verwendet.",
      outputPinAcıklama : "Wählen Sie die physische Pin-Nummer aus, an die dieser Ausgang angeschlossen wird. Jeder Pin kann nur einmal verwendet werden und darf nicht mit anderen Ausgängen in Konflikt stehen.",
      röleAcıklama : "Bestimmt den Betriebstyp des Ausgangs. Disabled: Deaktiviert, Enabled: Aktiv, Fix: Fester Betrieb, Relay: Relaissteuerung",
      currenlimitacıklama : "Bestimmt das maximale Stromlimit dieses Ausgangs (in Ampere). Dieser Wert sollte aus Sicherheitsgründen nicht überschritten werden.",
      outputSayfa : "Bestimmt, auf welcher Seite dieser Ausgang angezeigt wird. Wird zur Organisation zwischen Seiten verwendet.",
      outuptSatır : "Bestimmt, in welcher Zeile dieser Ausgang auf der Seite platziert wird. Die Seite muss zuerst ausgewählt werden.",
      stunoutput : "Bestimmt, in welcher Spalte dieser Ausgang in der ausgewählten Zeile platziert wird. Seite und Zeile müssen zuerst ausgewählt werden.",
      klonlaoutpusayfa : "Bestimmt, auf welcher Seite dieser Ausgang an der zweiten Position angezeigt wird. Derselbe Ausgang kann an mehreren Stellen angezeigt werden.",
      klonlarowoutput : "Bestimmt, in welcher Zeile dieser Ausgang an der zweiten Position platziert wird. Sie können ein anderes Layout auf der zweiten Seite erstellen.",
      klonlacolmoutputt : "Bestimmt, in welcher Spalte dieser Ausgang an der zweiten Position platziert wird. Sie können verschiedene Positionen auf verschiedenen Seiten auswählen.",

      akımlimitiaçıklama : "Stromlimit für diesen Ausgang, um im sicheren (grünen) Bereich zu bleiben. Dieser Wert kann das Stromlimit nicht überschreiten und wird als Sicherheitsindikator verwendet.",
      ikonaçıklamaoutput : "Wählen Sie das visuelle Symbol aus, das für diesen Ausgang verwendet werden soll. Das Symbol wird verwendet, um den Ausgang in der Benutzeroberfläche zu identifizieren.",
      
      inputpinaçıklama : "Wählen Sie die physische Pin-Nummer aus, an die dieser Eingang angeschlossen wird. Jeder Pin kann nur einmal verwendet werden.",
      enableaçıklama : "Wählen Sie aus, ob dieser Eingang aktiv sein soll oder nicht.",
      vaivenaçıklama : "Wählen Sie den Ausgangspin aus, den dieser Eingang auslösen soll.",
      inğutpageaçıklama : "Wählen Sie die Seitenzahl aus, auf der dieser Eingang angezeigt werden soll.",
      girişinsıranu : "Wählen Sie die Zeilennummer aus, auf der dieser Eingang angezeigt werden soll.",
      girişinkolonnumarası : "Wählen Sie die Spaltennummer aus, auf der dieser Eingang angezeigt werden soll.",
      succes : "Erfolgreich",
      removeFilses : "Datei löschen",
      showFiles : "Datei anzeigen",
      fileOperation: "Dateioperationen",
      temprature : "Temperatur",  
      numberOfTemprature : "Nummer",  
      isTempratureEnable : "Temperatur Aktiv",  
      location : "Standort",  
      right : "Rechts",  
      left : "Links",
        profilbg: "Profil erfolgreich aktualisiert.",
        profilbas: "Aktualisierung fehlgeschlagen.",
        bhataol: "Ein Fehler ist aufgetreten.",
        profbilgi: "Profilinformationen",
        update: "Aktualisieren",
        kaara : "Search by configuration name",
        kag : "Konfigurationsname.",
        negatifdg: "Sie können keinen negativen Wert eingeben.",
        tsuiuy: "Der Warnprozentsatz für sauberes Wasser muss größer sein als der Fehlerprozentsatz.",
        kgsiu: "Der Warnprozentsatz für schmutziges/graues Wasser muss kleiner sein als der Fehlerprozentsatz.",
        exit: "Abmelden",
        profile: "Mein Profil",
        konfig: "Meine Konfigurationen",
        ukb: "Benutzerkonfigurationsinformationen",
        ub: "Benutzerinformationen",
        kyt: "Benutzerhilfsanfragen",
        layoutTitle: "Octoopi Van Konfigurator",
        layoutFooter: "© 2024 Octoopi Systems",
        pages: "Seiten",
        outputs: "Ausgänge",
        addPage: "Seite hinzufügen",
        addOutput: "Ausgang hinzufügen",
        deleteConfirm: "Sind Sie sicher, dass Sie dieses Element löschen möchten?",
        yes: "Ja",
        no: "Nein",
        saveChanges: "Änderungen speichern und herunterladen",
        firstRowCapacity: "Kapazität der ersten Reihe",
        secondRowCapacity: "Kapazität der zweiten Reihe",
        pageAlias: "Seitenalias",
        socketpin: "Sockelpin",
        type: "Typ",
        currentLimit: "Strombegrenzung (A)",
        page: "Seite",
        column: "Spalte",
        row: "Reihe",
        clone: "Klonen",
        currentGreenLimit: "Aktuelle grüne Grenze (A)",
        icon: "Symbol",
        nameTR: "Name (TR)",
        nameGB: "Name (GB)",
        nameDE: "Name (DE)",
        delete: "Löschen",
        dkvi: "Änderungen speichern und herunterladen",
        forceShutDownVoltage: "Zwangsabschaltspannung (V)",
        optionalDownVoltage: "Optionale Abschaltspannung",
        startWarnVoltage: "Warnschwellenspannung (V)",
        recoverVoltage: "Wiederherstellungsspannung",
        forceShutDownTime: "Zwangsabschaltzeit (Sekunden)",
        setting: "Einstellung",
        shortCircuitSocketpin: "Kurzschlusssockelpin",
        openCircuitSocketpin: "Offener Schaltkreissockelpin",
        shortCircuitVoltage: "Kurzschluss-Spannung (V)",
        openCircuitVoltage: "Offene Schaltkreis-Spannung (V)",
        manualOverrideDuration: "Manuelle Übersteuerungsdauer (Sekunden)",
        relay: "Relais",
        active: "Aktiv",
        floats: "Schwimmer",
        voltages: "Spannungen",
        inputs: "Eingänge",
        addInput: "Eingang hinzufügen",
        addVoltage: "Spannung hinzufügen",
        addFloat: "Schwimmer hinzufügen",
        empty: "Leer",
        water: "Wasser",
        drain: "Ablauf",
        gray: "Grau",
        purpose: "Zweck",
        warnPercent: "Warnprozentsatz",
        errorPercent: "Fehlerprozentsatz",
        lock_pin: "Sperr-Pin",
        enable: "Aktivieren",
        vavienOutput: "Vavien-Ausgang",
        disabled: "Deaktiviert",
        enabled: "Aktiviert",
        Fix: "Fixieren",
        selectIcon: "Symbol auswählen",
        deleteClone:"Klon löschen",
        page2: "Seite 2",
        column2: "Spalte 2",
        row2: "Reihe 2",
        optional: "Optional",
        companyName: "Firmenname",
        caravanType: "Wohnmobiltyp",
        description: "Beschreibung",
        customerNameSurname: "Kundenname Nachname",
        customerPhone: "Kundentelefon",
        customerCountry: "Kundenland",
        customerInformation : "Kundeninformationen",
        howUsing: "Wie benutzt man?",
        adminLogin: "Admin-Anmeldung",
        oneContent: "Die B- und S-Serie, die grundlegendsten Produkte der Octoopi Van-Serie, bieten Caravan-Nutzern den Komfort, Informationen über den Wohnbereich zu erhalten. Unsere Produkte bestehen aus zwei Teilen: einem Touch-Bildschirm für den Benutzer und einer Stromsteuerungsschnittstelle und bieten zwei verschiedene Bildschirmoptionen: 4,3 und 7 Zoll. Dank der fortschrittlichen Schnittstelle und der technologischen Stromsteuerungseinheit können Benutzer mit den B- und S-Serien-Produkten alle Arten von Informationen erhalten. Mit seinem MultiColor- und Glass+Glass-kapazitiven Touchscreen bietet es eine so einfache Benutzererfahrung wie ein Mobiltelefon. Mit Halbleiter-Leistungstreibern und digitalen/analogen Eingängen bieten wir Ihnen ein intelligentes System mit der Octoopi Van-Serie. Durch das lokale Design und die Produktion von Octoopi gewährleisten Installation und technischer Support zusätzliche Zufriedenheit für unsere geschätzten Benutzer auch nach dem Verkauf.",
        requestHelp: "Hilfe anfordern",
        areaRequired: "Dieses Feld ist erforderlich.",
        titile: "Titel",
        plaseEnter: "Bitte geben Sie Ihre E-Mail-Adresse ein, damit wir Sie erreichen können.",
        helpReq: "Schreiben Sie hier die Details Ihrer Hilfsanfrage...",
        sendRequest: "Anfrage senden",
        outputPin : "Ausgangspin",
        inputPin: "Eingangspin",
        voltagesPin : "Spannungspin",
        floatsPin : "Schwimmerpin",
        outputName : "Ausgang",
        inputName : "Eingang",
        voltageName : "Spannung",
        floatName : "Schwimmer",
        sgy: "Im System anmelden",
        email: "E-Mail-Adresse",
        password: "Passwort",
        newPassword: "Neues Passwort",
        confirmPassword: "Passwort bestätigen",
        passwordMismatch: "Passwörter stimmen nicht überein!",
        passwordUpdateTitle: "Passwort aktualisieren",
        passwordSuccess: "Passwort erfolgreich aktualisiert.",
        gy: "Anmelden",
        hym: "Noch kein Konto?",
        ho: "Konto erstellen",
        sgyö: "Bevor Sie sich anmelden",
        kog: "müssen Sie sich registrieren.",
        ehv: "Wenn Sie bereits ein Konto haben",
        sükgy: "können Sie sich oben rechts anmelden.",
        kf: "Benutzerformular",
        name: "Vorname",
        surname: "Nachname",
        fa: "Firmenname",
        kt: "Wohnwagen-Typ",
        description: "Beschreibung",
        customerPhone: "Kundentelefon",
        country: "Land",
        submit: "Registrieren",
        login: "Anmelden",
        yke: "Neue Konfiguration hinzufügen",
        kdi: "Konfigurationsdatei herunterladen",
        ot: "Erstellt am",
        gt: "Aktualisiert am",
        dowland: "Herunterladen",
        nk: "Anleitung",
        sae: "1. Seitenbildschirm",
        sefeat: "Der Seitenbildschirm repräsentiert verschiedene UI-Seiten. Sie können bis zu 10 Seiten duplizieren. Während der Konfiguration legen Sie die Kapazität dieser Seiten fest. Jede Seite kann maximal 5 und minimal 0 Symbole aufnehmen. Dieser Schritt muss zuerst abgeschlossen werden.",
        içç: "2. Ausgänge",
        bepy: "Auf diesem Bildschirm werden Ausgangspins konfiguriert. Strombegrenzung und Pin werden festgelegt. Strombegrenzung: Der maximale Stromwert. Grüner Stromgrenzwert: Der minimale Strom, bei dem das Gerät normal arbeitet. Um den Ausgang zu aktivieren, setzen Sie den Typ auf „aktiv“.",
        titlee: "Titel",
        mail: "E-Mail",
        description: "Beschreibung",
        tb: "Anfrage senden",
        ytb: "Support-Anfrage absenden",
        ytb : "Hilfe anfordern",
        search : "Suchen",
        clean : "Löschen",
        yb : "Hilfetitel",
        ya : "Hilfebeschreibung",
        km : "Benutzer-E-Mail",
        kl : "Konfigurationen auflisten",
        ci : "Konfiguration herunterladen",
        cid: "Konfig-ID",
        ka : "Benutzername",
        mid : "Kunden-ID",
        kaa : "Benutzername suchen",
        mia : "Kunden-ID suchen",
        adi : "Vorname",
        soyadi : "Nachname",
        işlem : "Aktion",
        aylalg : "Das aktuelle grüne Limit kann das aktuelle Limit nicht überschreiten!"

      }
  };
  
  export default locales;
  